var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTemperatura(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#040006;}.cls-3{fill:#ea0000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-temperatura") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_22",
    "data-name": 22
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.71,47.83h.19a12,12,0,0,1,11.64,12.08c0,8.61,0,17.39,0,25.87,0,3.83,0,7.66,0,11.49v7.66c0,9.87,0,20.07,0,30.09a9.71,9.71,0,0,0,3.86,8,25.49,25.49,0,1,1-31.7.06,9.89,9.89,0,0,0,3.94-8.17c0-22.74,0-47.14,0-74.61,0-7.13,5.2-12.52,12.1-12.52m0-6.67c-10.58,0-18.77,8.31-18.78,19.19q0,37.31,0,74.62a3.23,3.23,0,0,1-1.37,2.9,32.16,32.16,0,1,0,39.93-.06,3.07,3.07,0,0,1-1.3-2.76c0-12.59,0-25.18,0-37.77s.05-24.93,0-37.4A18.67,18.67,0,0,0,114,41.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.23,112.6c-1.82,0-3.65.05-5.48,0-2.1-.06-3.34-1.26-3.3-3.09s1.24-2.92,3.26-3c3.71-.06,7.43-.06,11.14,0a3,3,0,1,1,0,6C151,112.66,149.12,112.6,147.23,112.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.35,69c1.89,0,3.78,0,5.66,0a3,3,0,1,1,.09,5.92c-3.89.06-7.79.06-11.68,0a3,3,0,1,1,.09-5.92C143.45,68.94,145.4,69,147.35,69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.12,131.38c-1.82,0-3.65,0-5.48,0a2.94,2.94,0,0,1-3.19-3c0-1.79,1.17-2.95,3.19-3,3.78,0,7.55-.06,11.33,0a2.94,2.94,0,0,1,3.13,3.07,3,3,0,0,1-3.13,2.89C151,131.42,149.07,131.39,147.12,131.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.13,93.75c-1.82,0-3.65,0-5.47,0-2-.06-3.2-1.19-3.21-3a2.9,2.9,0,0,1,3.18-3c3.77,0,7.55,0,11.32,0a3,3,0,1,1,0,6h-5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.85,130.2c0,2.94.05,5.87,0,8.8a7.61,7.61,0,0,0,4,7.09c7,4.41,10.34,10.91,9.43,19.09-1,8.42-5.79,14.14-13.86,16.77a19.78,19.78,0,0,1-16.57-35.51,8.69,8.69,0,0,0,4.54-8.46c-.17-5.62,0-11.24,0-16.87,0-3.91,2.55-6.74,6.13-6.82s6.36,2.76,6.4,6.74C119.87,124.09,119.85,127.15,119.85,130.2Zm-6.84,47c2,0,3.24-1,3.31-2.63s-1-2.69-2.9-2.87c-4.77-.45-7.46-3.14-8-8-.18-1.82-1.33-3-2.89-2.92S100,162.11,100,164A13.62,13.62,0,0,0,113,177.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTemperatura);
export default __webpack_public_path__ + "static/media/ic-temperatura.c8ecdf2577311d9f0babfcf403e3253b.svg";
export { ForwardRef as ReactComponent };